const MARKETPLACE_CATEGORY_TRANSLATION_KEYS: Record<string, string> = {
  "engineering & it": "categoryNames.engineeringIt",
  operations: "categoryNames.operations",
  productivity: "categoryNames.productivity",
  support: "categoryNames.support",
  marketing: "categoryNames.marketing",
  hr: "categoryNames.hr",
  "finance & accounting": "categoryNames.financeAccounting",
  sales: "categoryNames.sales",
  "legal & compliance": "categoryNames.legalCompliance",
  "data & analytics": "categoryNames.dataAnalytics",
  "customer success": "categoryNames.customerSuccess",
  "security & risk": "categoryNames.securityRisk",
};

const MARKETPLACE_SUBCATEGORY_TRANSLATION_KEYS: Record<string, string> = {
  outreach: "subcategoryNames.outreach",
  crm: "subcategoryNames.crm",
  pipeline: "subcategoryNames.pipeline",
  "quoting & proposals": "subcategoryNames.quotingProposals",
  "sales operations": "subcategoryNames.salesOperations",
  content: "subcategoryNames.content",
  campaigns: "subcategoryNames.campaigns",
  social: "subcategoryNames.social",
  email: "subcategoryNames.email",
  "seo & web": "subcategoryNames.seoWeb",
  "events & webinars": "subcategoryNames.eventsWebinars",
  ticketing: "subcategoryNames.ticketing",
  "knowledge & self-service": "subcategoryNames.knowledgeSelfService",
  "chat & voice automation": "subcategoryNames.chatVoiceAutomation",
  "escalations & sla": "subcategoryNames.escalationsSla",
  approvals: "subcategoryNames.approvals",
  procurement: "subcategoryNames.procurement",
  "vendor management": "subcategoryNames.vendorManagement",
  "internal requests": "subcategoryNames.internalRequests",
  "quality & audit": "subcategoryNames.qualityAudit",
  recruiting: "subcategoryNames.recruiting",
  "onboarding & offboarding": "subcategoryNames.onboardingOffboarding",
  "learning & development": "subcategoryNames.learningDevelopment",
  "payroll & benefits": "subcategoryNames.payrollBenefits",
  research: "subcategoryNames.research",
  "meetings & notes": "subcategoryNames.meetingsNotes",
  "document automation": "subcategoryNames.documentAutomation",
  "scheduling & calendar": "subcategoryNames.schedulingCalendar",
  "general assistant": "subcategoryNames.generalAssistant",
  "devops & ci/cd": "subcategoryNames.devopsCiCd",
  "incidents & sre": "subcategoryNames.incidentsSre",
  "internal tools": "subcategoryNames.internalTools",
  "monitoring & observability": "subcategoryNames.monitoringObservability",
  "code, docs & review": "subcategoryNames.codeDocsReview",
  "ap & ar": "subcategoryNames.apAr",
  "financial reporting": "subcategoryNames.financialReporting",
  "expense & reimbursement": "subcategoryNames.expenseReimbursement",
  "billing & revenue": "subcategoryNames.billingRevenue",
  "contracts & clm": "subcategoryNames.contractsClm",
  "privacy & data rights": "subcategoryNames.privacyDataRights",
  "regulatory reporting": "subcategoryNames.regulatoryReporting",
  "policies & governance": "subcategoryNames.policiesGovernance",
  "bi & reporting": "subcategoryNames.biReporting",
  "data pipelines": "subcategoryNames.dataPipelines",
  experimentation: "subcategoryNames.experimentation",
  "product & customer analytics": "subcategoryNames.productCustomerAnalytics",
  "onboarding playbooks": "subcategoryNames.onboardingPlaybooks",
  "health & adoption": "subcategoryNames.healthAdoption",
  "renewals & expansion": "subcategoryNames.renewalsExpansion",
  "executive reviews & qbrs": "subcategoryNames.executiveReviewsQbrs",
  "identity & access": "subcategoryNames.identityAccess",
  "vulnerability & risk": "subcategoryNames.vulnerabilityRisk",
  "security operations": "subcategoryNames.securityOperations",
  "third-party & vendor risk": "subcategoryNames.thirdPartyVendorRisk",
};

const MARKETPLACE_TAG_TRANSLATION_KEYS: Record<string, string> = {
  billing: "tagNames.billing",
  dashboard: "tagNames.dashboard",
  "real-time": "tagNames.realTime",
  realtime: "tagNames.realTime",
  video: "tagNames.video",
  image: "tagNames.image",
  email: "tagNames.email",
  procurement: "tagNames.procurement",
};

const INVALID_MARKETPLACE_CATEGORY_VALUES = new Set([
  "na",
  "n/a",
  "none",
  "null",
  "undefined",
  "-",
  "--",
]);

export function isValidMarketplaceCategoryValue(
  value: string | null | undefined,
): value is string {
  const normalized = value?.trim().toLowerCase();
  if (!normalized || /^\d+(?:\.\d+)?$/.test(normalized)) return false;
  return !INVALID_MARKETPLACE_CATEGORY_VALUES.has(normalized);
}

export function getMarketplaceCategoryTranslationKey(value: string) {
  return MARKETPLACE_CATEGORY_TRANSLATION_KEYS[value.trim().toLowerCase()];
}

export function getMarketplaceSubcategoryTranslationKey(value: string) {
  return MARKETPLACE_SUBCATEGORY_TRANSLATION_KEYS[value.trim().toLowerCase()];
}

export function getMarketplaceTagTranslationKey(value: string) {
  return (
    MARKETPLACE_TAG_TRANSLATION_KEYS[value.trim().toLowerCase()] ??
    getMarketplaceSubcategoryTranslationKey(value)
  );
}

export function isMeaningfulMarketplaceDisplayValue(
  value: unknown,
): value is string {
  return (
    typeof value === "string" &&
    isValidMarketplaceCategoryValue(value) &&
    value.trim().toLowerCase() !== ".ss"
  );
}
